import scopeThreePreviewRegistry from "./scopeThreePreviewRegistry";
import {
  CapitalGoodsPreview,
  BusinessTravelPreview,
  DownstreamLeasedAssetsPreview,
  DownstreamTransportationAndDistributionPreview,
  EmployeeCommutingPreview,
  FranchisePreview,
  InvestmentsPreview,
  ProcessingOfSoldProductsPreview,
  UpstreamLeasedAssetsPreview,
  UseOfSoldProductsPreview,
  FuelAndEnergyRelatedActivitiesPreview,
  TreatmentOfSoldProductsPreview,
  UpstreamTransportationAndDistributionPreview,
  WasteGeneratedInOperationsPreview,
  PurchasedGoodsAndServicesPreview
} from "./components/categories";
import { SCOPE_3_CATEGORIES_KEYS } from "./const";

scopeThreePreviewRegistry.register(SCOPE_3_CATEGORIES_KEYS.purchasedGoodsAndServicesDto, PurchasedGoodsAndServicesPreview);
scopeThreePreviewRegistry.register(SCOPE_3_CATEGORIES_KEYS.capitalGoods, CapitalGoodsPreview);
scopeThreePreviewRegistry.register(SCOPE_3_CATEGORIES_KEYS.fuelAndEnergyRelatedActivities, FuelAndEnergyRelatedActivitiesPreview);
scopeThreePreviewRegistry.register(SCOPE_3_CATEGORIES_KEYS.upstreamTransportationAndDistribution, UpstreamTransportationAndDistributionPreview);
scopeThreePreviewRegistry.register(SCOPE_3_CATEGORIES_KEYS.wasteGeneratedInOperations, WasteGeneratedInOperationsPreview);
scopeThreePreviewRegistry.register(SCOPE_3_CATEGORIES_KEYS.businessTravel, BusinessTravelPreview);
scopeThreePreviewRegistry.register(SCOPE_3_CATEGORIES_KEYS.downstreamLeasedAssets, DownstreamLeasedAssetsPreview);
scopeThreePreviewRegistry.register(SCOPE_3_CATEGORIES_KEYS.downstreamTransportationAndDistribution, DownstreamTransportationAndDistributionPreview);
scopeThreePreviewRegistry.register(SCOPE_3_CATEGORIES_KEYS.employeeCommuting, EmployeeCommutingPreview);
scopeThreePreviewRegistry.register(SCOPE_3_CATEGORIES_KEYS.franchises, FranchisePreview);
scopeThreePreviewRegistry.register(SCOPE_3_CATEGORIES_KEYS.investments, InvestmentsPreview);
scopeThreePreviewRegistry.register(SCOPE_3_CATEGORIES_KEYS.processingOfSoldProducts, ProcessingOfSoldProductsPreview);
scopeThreePreviewRegistry.register(SCOPE_3_CATEGORIES_KEYS.upstreamLeasedAssets, UpstreamLeasedAssetsPreview);
scopeThreePreviewRegistry.register(SCOPE_3_CATEGORIES_KEYS.useOfSoldProducts, UseOfSoldProductsPreview);
scopeThreePreviewRegistry.register(SCOPE_3_CATEGORIES_KEYS.treatmentOfSoldProducts, TreatmentOfSoldProductsPreview);

export { default as ScopeThree } from "./ScopeThree";